export default "__VITE_ASSET__DTdPkoCu__"